import React, { useEffect, useState } from "react";
import Itemstable, {ProductImageCell} from "./Itemstable";
function Itemsdata() {
  let [products, setProducts] = useState({
    count: 4,
  });

  var counter = 5;
  console.log("outside count", products.count);
  const handleChange = (e) => {
    console.log("inside handel chnage count", products.count);
    if (e.target.value > 0) {
      setProducts({ count: e.target.value || 0 });
    } else {
      console.log("out of stock");
    }
  };

  const decrease = (e) => {
    if (products.count <= 0) {
      return;
    }
    console.log("count in decrease", products.count);
    console.log("e.target.value", e.target.value);

    if (e.target.value > 0) {
      counter = counter - parseInt(e.target.value);
      if (counter == 0 || counter < 0) {
        alert("out of stock");
        counter = 0;
      }
      setProducts({ count: products.count - e.target.value });
      console.log("inside if", products.count);
    } else {
      console.log("out of stock");
    }
    console.log("count", products.count);
  };

  const data = [
    {
      id: "1",
      number: "10254354545",
      itemname: "Dutch Grown",
      version: "1.2",
      stock: "1",
    },
    {
      id: "2",
      number: "10254354545",
      itemname: "Cambo",
      version: "1.2",
      stock: "1",
    },
    {
      id: "3",
      number: "10254354545",
      itemname: "Avon Bulbs",
      version: "1.2",
      stock: "2",
    },
    {
      id: "4",
      number: "10254354545",
      itemname: "Broardleight Bulbs",
      version: "1.2",
      stock: "4",
    },
    {
      id: "5",
      number: "10254354545",
      itemname: "Dutch Grown",
      version: "1.2",
      stock: "10",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },

      {
        Header: "Number",
        accessor: "number",
      },
      {
        Header: "Item Name",
        accessor: "itemname",
      },
      {
        Header: "Image",
        accessor: "img",
        Cell: ProductImageCell,
      },
      {
        Header: "Version",
        accessor: "version",
      },
      {
        Header: "QTY in Stock",
        accessor: "stock",
        Cell: (value) => (
          <div class=" flex w-1/2 mr-8 ">
            <input
              class="w-full bg-transparent p-2"
              type="text"
              // value={products.count}
              value={counter}
              onChange={(e) => {
                decrease(e);
                handleChange(e);
              }}
              // onChange={handleChange}
            />
          </div>
        ),
      },
      {
        Header: "Pick QTY",
        accessor: "pick",
        Cell: (value) => (
          <div class=" flex border  w-3/4 mr-8 border-violet-800 rounded-lg">
            <input
              class="w-full rounded-lg p-2"
              type="text"
              onChange={decrease}
            />
          </div>
        ),
      },
     
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <Itemstable
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default Itemsdata;
